import React, { FC } from 'react'

import { IconMotionSensorProps } from './IconMotionSensor.types'
import * as Styled from './styles/IconMotionSensor.style'

import { nonThemeableRules } from '../../ruleSet'

const IconMotionSensor: FC<IconMotionSensorProps> = ({
  size = nonThemeableRules.defaultSize as number as IconMotionSensorProps['size'],
  isResponsive = false,
}: IconMotionSensorProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <g clipPath='url(#1d4de5e1-905d-4ffe-96b8-36a566b65e35__a)' strokeLinecap='round' strokeWidth='2'>
          <path d='M15 23.938a9 9 0 0 1 9-8.988' stroke='#E60000' strokeLinejoin='round' />
          <path d='M10.963 24A13.032 13.032 0 0 1 24 10.978' stroke='#E60000' strokeLinejoin='round' />
          <path d='M6.962 23.965A17.03 17.03 0 0 1 24 6.935' stroke='#E60000' strokeLinejoin='round' />
          <path
            d='M23.275 18.96H41v17.712a4.325 4.325 0 0 1-4.325 4.325h-13.4a4.325 4.325 0 0 1-4.325-4.325V23.285a4.325 4.325 0 0 1 4.325-4.325Z'
            stroke='#0D0D0D'
          />
        </g>
        <defs>
          <clipPath id='1d4de5e1-905d-4ffe-96b8-36a566b65e35__a'>
            <path d='M0 0h48v48H0z' fill='#fff' />
          </clipPath>
        </defs>
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconMotionSensor
